import axios from "axios";

export default {
  getNotifications(params = {}) {
    return axios.get('/notifications', { params })
  },
  getUnreadCount() {
    return axios.get(`/notifications/unread-count`)
  },
  read(notificationId) {
    return axios.post(`/notifications/${notificationId}/read`)
  },
  readAll() {
    return axios.post(`/notifications/read-all`);
  },
  async clearAll() {
    return axios.delete('/notifications/clear-all');
  },
  getPreferences() {
    return axios.get('/user/notification-preferences', { skipErrorToast: true });
  },
  updatePreferences(payload) {
    return axios.patch('/user/notification-preferences', payload, { skipErrorToast: true });
  },
};
